import { SAVE_USER_NAME, SAVE_LOAN_ID } from "./Constants";

const INTIAL_STATE = {
  userName: "",
  loanId: "",
  auditType: "",
  performedOn: "",
};

export default function auditTrailReducer (state = INTIAL_STATE, action) {
  switch (action.type) {
    case SAVE_USER_NAME:
      return {
        ...state,
        userName: action.data.userName,
        auditType: action.data.auditType,
        performedOn: action.data.performedOn,
      };
    case SAVE_LOAN_ID:
      return {
        ...state,
        performedOn: action.data.performedOn,
        auditType: action.data.auditType,
      };
    default:
      return state;
  }
}
